import { render, staticRenderFns } from "./backupcode.vue?vue&type=template&id=7b433f6a&scoped=true"
import script from "./backupcode.vue?vue&type=script&lang=js"
export * from "./backupcode.vue?vue&type=script&lang=js"
import style0 from "./backupcode.vue?vue&type=style&index=0&id=7b433f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b433f6a",
  null
  
)

export default component.exports